import { useAppSelector } from 'app/hooks'
import { selectProductsBySlug, selectResultsIsLoading } from 'app/results/resultsSlice'
import { noSelector, selectProductSearchQuery } from 'app/selectors'
import { useSearchProductsQuery } from 'app/services/api'
import { ProductSearchArgs } from 'types'

const useProducts = (args?: ProductSearchArgs, skip?: boolean) => {
  const searchArgs = useAppSelector(args ? noSelector(args) : selectProductSearchQuery)
  const { data, ...query } = useSearchProductsQuery(searchArgs ?? {}, { skip })
  const resultsLoading = useAppSelector(selectResultsIsLoading)
  
  const slugs = (data?.products?.nodes || []).reduce((productSlugs, maybeProduct) => {
    return maybeProduct?.slug ? productSlugs.concat(maybeProduct.slug) : productSlugs
  }, [] as string[])

  const products = useAppSelector(selectProductsBySlug(slugs))

  return {
    products,
    resultsLoading,
    data,
    ...query,
  }
}

export default useProducts
